import React from 'react';
import PropTypes from 'prop-types';
import { Header, Logo } from '@mhub/web-components';

import './styles.css';
import LanguageSelector from '../LanguageSelector';

const AppHeader = ({ header, children, loading }) => (
  <div>
    {window.location.pathname.includes('/login') && (
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
        <LanguageSelector />
      </div>
    )}
    <div className="app-header">
      <Logo className="logo" alt="Logo" loading={loading} />
      <Header as="h4" bold={false} fluid>
        {header}
      </Header>
      {children}
    </div>
  </div>
);

AppHeader.propTypes = {
  header: PropTypes.string,
  children: PropTypes.node,
  loading: PropTypes.bool,
};

AppHeader.defaultProps = {
  header: '',
  children: null,
  loading: false,
};

export default AppHeader;
